import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuthToken } from '../../Utils/auth.ts';

let isUnauthorizedHandled = false;
let isServerErrorHandled = false;

const handleUnauthorized = () => {
  if (isUnauthorizedHandled) return;
  isUnauthorizedHandled = true;

  localStorage.clear();
  toast.error("Login Expired.");

  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage('logout');
  }
};

const handleServerError = () => {
  if (isServerErrorHandled) return;
  isServerErrorHandled = true;

  toast.error("Server Error");
};

    export const getOrders = (per_page_records: number, page_number: number,status:string,source:string,time_period:any,trip_id:any,order_id:any,customer_name:string,customer_phone:any,customer_state:string,vehicles_id:any,warehouses_ids:any,ofd_sort:number, _successCallback: (response: any) => void, _errorCallback: (errMessage: string) => void) => {
    axios.get(`${global.api_url}/api/orders?per_page_records=${per_page_records}&page_number=${page_number}&status=${status}&source=${source}&time_period=${time_period}&trip_id=${trip_id}&order_id=${order_id}&customer_name=${customer_name}&customer_phone=${customer_phone}&customer_state=${customer_state}&vehicles_id=${vehicles_id}&warehouses_ids=${warehouses_ids}&ofd_sort=${ofd_sort}`, {
        headers: {
             Accept: "application/json",
              Authorization: `Bearer ${getAuthToken()}`
        }
    })
        .then((response: AxiosResponse) => {
            _successCallback(response.data);
        })
        .catch((error: AxiosError) => {
            if (error.response?.status == 401) {
               handleUnauthorized();
            }
            else
                _errorCallback(error.message + (error.response?.statusText ? ': ' + error.response?.statusText : "") || 'Something went wrong, please try again.');
        });
}


  export const getItems = (per_page_records: number, page_number: number,order_id:any, _successCallback: (response: any) => void, _errorCallback: (errMessage: string) => void) => {
    axios.get(`${global.api_url}/api/list_items?orders_id=${order_id}&per_page_records=${per_page_records}&page_number=${page_number}`, {
        headers: {
              Authorization: `Bearer ${getAuthToken()}`
        }
    })
        .then((response: AxiosResponse) => {
            _successCallback(response.data);
        })
        .catch((error: AxiosError) => {
            if (error.response?.status == 401) {
              handleUnauthorized();
            }
            else
                _errorCallback(error.message + (error.response?.statusText ? ': ' + error.response?.statusText : "") || 'Something went wrong, please try again.');
        });
}
export const editOrders = (
    order_id:any,
  warehouses_id: number,
  vehicles_id:any,
  status: string,
  amount_upi:any,
  amount_cash:any,
  remarks:any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const payload = { warehouses_id,vehicles_id,status,amount_upi,amount_cash,remarks};
  axios.put(`${global.api_url}/api/orders/${order_id}`, payload, {
    headers: {
      'Authorization': `Bearer ${getAuthToken()}`,
    },
  })
    .then((response: AxiosResponse) => {
      _successCallBack(response.data);
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
       handleUnauthorized();
      } else {
       handleServerError();
      }
    });
};
export const editItems = (
  id: number,
  status: string,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const payload = { id, status };

axios.put(
  `${global.api_url}/api/edit_items`,payload,
  {
    headers: {
      'Authorization': `Bearer ${getAuthToken()}`,
    },
  }
)

    .then((response: AxiosResponse) => {
      _successCallBack(response.data);
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        handleUnauthorized();
      } else {
        handleServerError();
      }
    });
};
